<template>
    <div id="newgroup">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="refresh" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Nouveau groupe
        </h1>
        <div class="container2">
            <div class="textline">
                <b class="textLen">Nom du groupe<i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                <input class="inputTxt" type="text"  v-model="group.address.lastName" >
            </div>
            <div class="textline">
                <b class="textLen">Complément de nom :</b>
                <input class="inputTxt" type="text"  v-model="group.address.firstName" >
            </div>
            <div class="textline">
                <b class="textLen">Adresse de référence :</b>
                <input class="inputTxt" type="text"  v-model="group.address.streetName" >
            </div>
            <div class="textline">
                <b class="textLen">Code postal :</b>
                <input class="inputTxt" type="text"  v-model="group.address.postalCode" >
            </div>
            <div class="textline">
                <b class="textLen">Ville :</b>
                <input class="inputTxt" type="text"  v-model="group.address.city" >
            </div>
            <div class="textline">
                <b class="textLen">Téléphone de référence :</b>
                <input class="inputTxt" type="text"  v-model="group.address.phoneNumber" >
            </div>
            <div class="textline">
                <b class="textLen">Email de référence :</b>
                <input class="inputTxt" type="text"  v-model="group.address.emailAddress" >
            </div>
            <div class="textline">
                <b class="textLen">Société :</b>
                <input class="inputTxt" type="text"  v-model="group.address.company" >
            </div>
        </div>
        <div class="container">
            <div class="textline">
                <b class="textLen">Type <i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                <select class="inputTxt select" v-model="group.type">
                    <option class="inputTxt" :value="''" selected>
                        Sélectionner
                    </option>
                    <option class="inputTxt" :value="'professionnel'">
                        Entreprise
                    </option>
                    <option class="inputTxt" :value="'architecte'">
                        Architecte
                    </option>
                    <option class="inputTxt" :value="'assurance'">
                        Assurance
                    </option>
                    <option class="inputTxt" :value="'agence immobilière'">
                        Agence Immobilière
                    </option>
                </select>
            </div>
            <div class="textline">
                <b class="textLen high">Bloc notes :</b>
                <textarea rows="8" class="inputTxt area" type="text"  v-model="group.note" ></textarea>
            </div>
        </div>
        <div class="btnContainer">
            <button v-on:click="uploadGroup()" class="btn">Valider</button>
        </div>
        
        <modal height="250px" width="400px" name="validationModal">
            <div class="modalDiv">  
                <div class="txtDiv">
                    <img class="modalTxt" :src="imgValidation"/>
                </div>  
                <div class="txtDiv">
                    <span class="modalTxt">{{validationPhrase}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Newgroup',
        data() {
            return {
                Name:"ADPR",
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                complement: "",
                validationPhrase: "Le nouvel utilisateur a été correctement enregistré",
                imgValidation: "/assets/right.png",
                idOfGroups : [],
                group: {
                    role :        "",
                    type :          '',
                    note :          "",
                    idWeweb :          "",
                    address:   {
                        streetNb:"",

                    }
                },
            };
        },
        methods:{
            openModal(){
                this.$modal.show('validationModal');
            },
            closeModal(){
                this.$modal.hide('validationModal');
            },
            okButton(){
                if(this.validationPhrase === "Le nouvel utilisateur a été correctement enregistré"){
                    this.goToGroupDetailPage(this.group.idWeweb);
                }
                else{
                    this.$modal.hide('validationModal');
                }
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            async uploadGroup(){
                this.group.role = "client";
                if(this.group.type !== "" && this.group.role !== "" && this.group.address.lastName !== ""){

                    if(this.group.address.firstName === ""){
                        this.group.address.firstName = " ";
                    }
                    
                    if(this.group.address.streetName){
                        var splitAddress = this.group.address.streetName.split(" ");
                        this.group.address.streetNb = parseInt(splitAddress[0]) || 0;
                    }
                    
                    var possible = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

                    var id = "";
                    for (var j = 0; j < 10; j++){
                        id += possible.charAt(Math.floor(Math.random() * possible.length));
                    }

                    while(this.idOfGroups.indexOf(id)>-1){
                        id = "";
                        for (var k = 0; k < 10; k++){
                            id += possible.charAt(Math.floor(Math.random() * possible.length));
                        }
                    }

                    this.group.idWeweb = id;
                    var response3 = await axios.post('https://so.gaviota.fr/api/groupdata/', {group: this.group});
                    if(response3){
                        this.validationPhrase =  "Le nouvel utilisateur a été correctement enregistré",
                        this.imgValidation = "/assets/right.png",
                        this.openModal();                        
                    }
                    else{
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModal();
                    }

                    
                }
                else{
                    this.validationPhrase =  "Veuillez remplir les champs obligatoires * ",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModal();
                }
            },
            goToGroupDetailPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "groupdetail", query:{name:this.group.idWeweb}});
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            refresh(){
                location.reload();
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            getCookies: function() {
                this.$cookie.set('currentAriane', "Bien n° " +this.$route.query.name);
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau")){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getGroupData();
                }
            },
            async getGroupData(){
                var response = await axios.get('https://so.gaviota.fr/api/groupdata/admin/all');
                if(response.data.groups){
                    for(var i=0; i<response.data.groups.length; i++){
                        if(response.data.groups[i].address){
                            this.idOfGroups.push(response.data.groups[i].idWeweb);
                        }
                    }
                }
            },
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #newgroup {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .btn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        display: inline-block;
        width: 100px;
    }
    .left{
        float:left;
    }
    .right{
        float:right;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
        cursor: pointer;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
    }
    .container2{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
    @media screen and (max-width: 768px) {
        .container2{
            -webkit-column-count: 1; /* Old Chrome, Safari and Opera */
            -moz-column-count: 1; /* Old Firefox */
            column-count: 1;
        }
    }
    .btnContainer{
        padding:20px;
        background-color: #FFF;
        margin-bottom: 20px;
        text-align: center;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:20px;
        right:20px;
        cursor:pointer;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .fifty{
        width:calc(50% - (25px + 50px));
        display: inline-block;
    }
    .inlineBlock{
        display: inline-block;
    }
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        margin:10px;
    }
    .area{
        resize: none;
        width: calc(100% - (100px + 50px));
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    h3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        margin: 0px 0px 0px 15px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .blockBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: block;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .high{
        height: 200px;
        vertical-align:top;
    }
</style>